import styled from 'styled-components'

const WyborStrukturyStyle = styled.div`
  background-color: ${props => props.theme.black4};
  margin: auto;
  display: grid;
  width: 1048px;
  height: 756px;
  padding: 12px;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 16px 12px;

    button {
      width: 112px;
    }
  }

  .container {
    overflow: auto;
  }
`

export default WyborStrukturyStyle
